import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { UserDeletionHistoryState, UserDeletionHistoryStateModel } from './user-deletion-history.state';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common/models';
import { UserDeletionHistoryInitialState, UserDeletionHistoryLoad } from './user-deletion-history.actions';
import { UserDeletionHistoryListSearchCriteria } from '../models/user-deletion-history.model';
import { ListSearchCriteriaFacade, ListSearchCriteriaType } from '../../../list-search-criteria';

@Injectable({ providedIn: 'root' })
export class UserDeletionHistoryFacade implements LoadDataFacade, SetInitialStateFacade {
  listDto$: Observable<UserDeletionHistoryStateModel> = this.store.select(UserDeletionHistoryState.getState);
  loaded$: Observable<boolean> = this.store.select(UserDeletionHistoryState.getLoaded);

  constructor(private store: Store, private listSearchCriteriaFacade: ListSearchCriteriaFacade) {}

  loadAll(): void {
    this.listSearchCriteriaFacade
      .getSearchCriteriaByListType(ListSearchCriteriaType.DeletionHistory)
      .subscribe((searchCriteria: UserDeletionHistoryListSearchCriteria) => {
        this.store.dispatch(new UserDeletionHistoryLoad(searchCriteria));
      });
  }

  setInitialState(): void {
    this.store.dispatch(new UserDeletionHistoryInitialState());
  }
}
